import React, { useRef } from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, shuffleArray } from '../../lib/ep.js';
import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';

import BattleFinal from './BattleFinal.js';

import BattleCanvas from '../games/BattleCanvas.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import SimpleCanvasContainer from './SimpleCanvasContainer.js';

const BattleClient = ({ stage, ...props }) => {
	const is_builder = props?.is_builder ?? false;
	const is_test = props?.is_test ?? false;

	const final_stage = JSON.parse(JSON.stringify(stage));
	final_stage.Stage.instructions_disabled = true;	// no instructions in this game_type
	final_stage.Stage.override_promo_styles = true;	// no final_page in this game_type
	if((!is_builder || is_test) && (stage.Stage?.faceoff_random_display ?? false)) {
		shuffleArray(final_stage?.Stage?.faceoff_players);
	}

	const final_answer = useRef({});

	const card_mode = stage?.Stage?.faceoff_players_mode ?? 'card';

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage.Stage, 'bg_image')) {
			images.push({
				id:'bg_image',
				name:stage.Stage.bg_image,
				url:stage.Stage.full_bg_image,
				fit:'cover',
				get_average_color:true,
			});
		}

		(isNotEmpty(stage.Stage, 'faceoff_players') ? stage.Stage.faceoff_players : []).map((player) => {
			if(isNotEmpty(player, 'image')) {
				images.push({
					id:`image_${player.id}`,
					name:player.image,
					url:player.full_image,
					image:player.full_image,
					fit:'contain',
					get_average_color:true,
				});
			}

			if(card_mode != 'card' && isNotEmpty(player, 'bg_image')) {
				images.push({
					id:`bg_image_${player.id}`,
					name:player.bg_image,
					url:player.full_bg_image,
					image:player.full_bg_image,
					fit:'contain',
					get_average_color:true,
				});
			}
		});

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.Stage?.faceoff_players,
			stage.Stage?.bg_image,
		],
	});

	const updateUserAnswer = (answer) => {
		final_answer.current = answer;
	};

	const display_losers = stage?.Stage?.faceoff_display_losers ?? false;
	const num_losers_per_row = stage?.Stage?.faceoff_loser_cols ?? 3;
	const final_key = `final_${(display_losers) ? '1' : '0'}_${num_losers_per_row}`;

	const default_props = {
		indexed_images:state.images,
		loaded_status:state.state,
		locale:props?.locale
	};

	const missing_anything = ((stage.Stage?.faceoff_players ?? []).length < 2) ? true : false;
	let preview_index = false;
	if(is_builder && !is_test) {
		preview_index = props?.preview_index ?? 1;
		if(preview_index == 0) preview_index = 1;
	}

	const display_player_text = stage.Stage?.faceoff_display_player_text ?? true;

	let full_key = `battle_${card_mode}`;
	if(display_player_text) full_key += `_texts`;

	const promotion = props?.promotion?.Promotion ?? (props?.promotion ?? {});

	return (
		<SimpleCanvasContainer
			{...props}
			key={full_key}
			stage={final_stage}
			final_page={<BattleFinal
				{...default_props}
				key={final_key}
				stats={props?.stats ?? {}}
			/>}
			game_type='battle'
		>
			{(missing_anything === false) ? (
				<BattleCanvas
					indexed_images={state.images}
					loaded_status={state.state}
					updateUserAnswer={updateUserAnswer}
					layout_props={promotion?.layout_props ?? {}}
					locale={props.locale}
					default_right_player_index={(preview_index !== false) ? preview_index : 1}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Upload at least 2 options"
					img_recommendations={{
						w:400,
						h:400,
					}}
				/>
			)}
		</SimpleCanvasContainer>
	)
};

export default injectIntl(BattleClient);